import Img from '@admin/components/html/img'
import PropTypes from 'prop-types'
import React from 'react'

class Video extends React.Component {

  static propTypes = {
    active: PropTypes.bool,
    video_url: PropTypes.string,
    image_url: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    source_icon: PropTypes.string,
    source_name: PropTypes.string
  }

  static defaultProps = {
    active: true
  }

  state = {
    playable: false
  }

  _handleClick = this._handleClick.bind(this)

  render() {
    const { active, image_url, title, text, source_name, source_icon } = this.props
    const { playable } = this.state
    return (
      <div className="maha-link-video">
        { playable ?
          <div className="maha-link-video-player">
            <iframe src={ this._getAutoplayUrl() } frameBorder="0" gesture="media" allowFullScreen></iframe>
          </div> :
          <div className="maha-link-video-image" onClick={ this._handleClick }>
            <Img src={ image_url} />
            { active && source_name === 'www.youtube.com' && <div className="maha-link-video-play" /> }
          </div>
        }
        <div className="maha-link-details">
          <div className="maha-link-title">
            { title }
          </div>
          { text &&
            <div className="maha-link-text">
              { text }
            </div>
          }
          <div className="maha-link-source">
            { source_icon && <Img src={ source_icon } />}
            { source_name }
          </div>
        </div>
      </div>
    )
  }

  _getAutoplayUrl() {
    const { video_url } = this.props
    const [,path,query] = video_url.match(/([^?]*)\??(.*)?/)
    const newquery = [
      ...(query || '').split('&'),
      'autoplay=1'
    ]
    return `${path}?${newquery.join('&')}`
  }

  _handleClick() {
    const { active } = this.props
    if(!active) return true
    this.setState({ playable: true })
  }

}

export default Video
